// Mock data for TERRACE — Scholastic Sport rankings clone.
// NOTE: Rankings below use real national-powerhouse high school program names
// arranged in a realistic format. Data is representative/mock for the demo.

export const SPORTS = [
  { id: "football", label: "Football", season: "Fall", image: "https://images.unsplash.com/photo-1537882111161-c3379a777c8b" },
  { id: "basketball", label: "Basketball", season: "Winter", image: "https://images.unsplash.com/photo-1608245449230-4ac19066d2d0" },
  { id: "soccer", label: "Soccer", season: "Fall", image: "https://images.unsplash.com/photo-1606925797300-0b35e9d1794e" },
  { id: "volleyball", label: "Volleyball", season: "Fall", image: "https://images.unsplash.com/photo-1547347298-4074fc3086f0" },
  { id: "lacrosse", label: "Lacrosse", season: "Spring", image: "https://images.unsplash.com/photo-1746826093063-92ad5a2f0f77" },
  { id: "squash", label: "Squash", season: "Winter", image: "https://images.unsplash.com/photo-1672068787369-82556699e538" },
];

// helper to derive movement from previous ranking
const mv = (rank, prev) => {
  if (prev === 0) return { dir: "new", value: 0 };
  if (prev > rank) return { dir: "up", value: prev - rank };
  if (prev < rank) return { dir: "down", value: rank - prev };
  return { dir: "same", value: 0 };
};

const build = (rows) =>
  rows.map((r) => ({ ...r, movement: mv(r.rank, r.prev) }));

export const RANKINGS = {
  football: build([
    { rank: 1, prev: 1, team: "Mater Dei", location: "Santa Ana, CA", record: "12–0", points: 1000, streak: "W12" },
    { rank: 2, prev: 3, team: "St. John Bosco", location: "Bellflower, CA", record: "11–1", points: 968, streak: "W7" },
    { rank: 3, prev: 2, team: "IMG Academy", location: "Bradenton, FL", record: "9–1", points: 940, streak: "W4" },
    { rank: 4, prev: 5, team: "Bishop Gorman", location: "Las Vegas, NV", record: "12–1", points: 915, streak: "W9" },
    { rank: 5, prev: 4, team: "Duncanville", location: "Duncanville, TX", record: "14–1", points: 902, streak: "W6" },
    { rank: 6, prev: 8, team: "Buford", location: "Buford, GA", record: "14–0", points: 878, streak: "W14" },
    { rank: 7, prev: 6, team: "Miami Central", location: "Miami, FL", record: "12–2", points: 851, streak: "W3" },
    { rank: 8, prev: 9, team: "Thompson", location: "Alabaster, AL", record: "13–1", points: 824, streak: "W11" },
    { rank: 9, prev: 7, team: "North Shore", location: "Houston, TX", record: "13–1", points: 806, streak: "W8" },
    { rank: 10, prev: 0, team: "Kahuku", location: "Kahuku, HI", record: "12–1", points: 780, streak: "W5" },
    { rank: 11, prev: 10, team: "Chaminade-Madonna", location: "Hollywood, FL", record: "11–2", points: 758, streak: "W2" },
    { rank: 12, prev: 14, team: "Gonzaga", location: "Washington, DC", record: "11–1", points: 733, streak: "W6" },
    { rank: 13, prev: 11, team: "Katy", location: "Katy, TX", record: "13–1", points: 710, streak: "W4" },
    { rank: 14, prev: 16, team: "Milton", location: "Milton, GA", record: "13–1", points: 688, streak: "W7" },
    { rank: 15, prev: 12, team: "Bergen Catholic", location: "Oradell, NJ", record: "10–2", points: 664, streak: "W1" },
    { rank: 16, prev: 18, team: "Center Grove", location: "Greenwood, IN", record: "14–1", points: 640, streak: "W9" },
    { rank: 17, prev: 13, team: "St. Frances Academy", location: "Baltimore, MD", record: "8–2", points: 618, streak: "W2" },
    { rank: 18, prev: 0, team: "Male", location: "Louisville, KY", record: "13–1", points: 595, streak: "W10" },
    { rank: 19, prev: 15, team: "Central Catholic", location: "Pittsburgh, PA", record: "12–2", points: 572, streak: "W3" },
    { rank: 20, prev: 21, team: "Lakeland", location: "Lakeland, FL", record: "13–1", points: 548, streak: "W8" },
    { rank: 21, prev: 17, team: "Corner Canyon", location: "Draper, UT", record: "13–1", points: 522, streak: "W5" },
    { rank: 22, prev: 0, team: "Grayson", location: "Loganville, GA", record: "12–2", points: 498, streak: "W4" },
    { rank: 23, prev: 19, team: "Servite", location: "Anaheim, CA", record: "9–3", points: 470, streak: "W1" },
    { rank: 24, prev: 22, team: "Westlake", location: "Austin, TX", record: "12–2", points: 445, streak: "W6" },
    { rank: 25, prev: 24, team: "East St. Louis", location: "East St. Louis, IL", record: "11–2", points: 420, streak: "W3" },
  ]),
  basketball: build([
    { rank: 1, prev: 1, team: "Montverde Academy", location: "Montverde, FL", record: "28–1", points: 1000, streak: "W18" },
    { rank: 2, prev: 4, team: "Columbus", location: "Miami, FL", record: "30–2", points: 962, streak: "W12" },
    { rank: 3, prev: 2, team: "Link Academy", location: "Branson, MO", record: "27–3", points: 938, streak: "W6" },
    { rank: 4, prev: 3, team: "Prolific Prep", location: "Napa, CA", record: "26–4", points: 910, streak: "W4" },
    { rank: 5, prev: 7, team: "AZ Compass Prep", location: "Chandler, AZ", record: "25–5", points: 884, streak: "W8" },
    { rank: 6, prev: 5, team: "Sierra Canyon", location: "Chatsworth, CA", record: "24–6", points: 860, streak: "W3" },
    { rank: 7, prev: 9, team: "Camden", location: "Camden, NJ", record: "29–2", points: 838, streak: "W10" },
    { rank: 8, prev: 6, team: "Wasatch Academy", location: "Mount Pleasant, UT", record: "23–6", points: 812, streak: "W2" },
    { rank: 9, prev: 12, team: "IMG Academy", location: "Bradenton, FL", record: "24–5", points: 788, streak: "W7" },
    { rank: 10, prev: 0, team: "Long Island Lutheran", location: "Brookville, NY", record: "26–3", points: 764, streak: "W5" },
    { rank: 11, prev: 8, team: "Roselle Catholic", location: "Roselle, NJ", record: "25–4", points: 740, streak: "W1" },
    { rank: 12, prev: 14, team: "Duncanville", location: "Duncanville, TX", record: "31–2", points: 716, streak: "W9" },
    { rank: 13, prev: 10, team: "Paul VI", location: "Chantilly, VA", record: "27–4", points: 692, streak: "W3" },
    { rank: 14, prev: 0, team: "Combine Academy", location: "Lincolnton, NC", record: "28–3", points: 668, streak: "W6" },
    { rank: 15, prev: 11, team: "Dynamic Prep", location: "Irving, TX", record: "24–5", points: 644, streak: "W2" },
    { rank: 16, prev: 18, team: "Bella Vista Prep", location: "Scottsdale, AZ", record: "23–6", points: 620, streak: "W4" },
    { rank: 17, prev: 13, team: "Legacy Early College", location: "Greenville, SC", record: "25–4", points: 596, streak: "W5" },
    { rank: 18, prev: 15, team: "Sunrise Christian", location: "Bel Aire, KS", record: "22–7", points: 572, streak: "W1" },
    { rank: 19, prev: 21, team: "La Lumiere", location: "La Porte, IN", record: "24–5", points: 548, streak: "W6" },
    { rank: 20, prev: 16, team: "Oak Hill Academy", location: "Mouth of Wilson, VA", record: "23–6", points: 524, streak: "W2" },
    { rank: 21, prev: 0, team: "Utah Prep", location: "Hurricane, UT", record: "26–4", points: 500, streak: "W7" },
    { rank: 22, prev: 19, team: "Corona Centennial", location: "Corona, CA", record: "28–4", points: 476, streak: "W3" },
    { rank: 23, prev: 20, team: "Grayson", location: "Loganville, GA", record: "27–3", points: 452, streak: "W8" },
    { rank: 24, prev: 22, team: "Brewster Academy", location: "Wolfeboro, NH", record: "22–7", points: 428, streak: "W2" },
    { rank: 25, prev: 23, team: "Bishop Gorman", location: "Las Vegas, NV", record: "26–4", points: 404, streak: "W4" },
  ]),
  soccer: build([
    { rank: 1, prev: 2, team: "Montverde Academy", location: "Montverde, FL", record: "18–0–2", points: 1000, streak: "W9" },
    { rank: 2, prev: 1, team: "St. Benedict's Prep", location: "Newark, NJ", record: "19–1–1", points: 965, streak: "W5" },
    { rank: 3, prev: 3, team: "Naperville North", location: "Naperville, IL", record: "22–0–1", points: 938, streak: "W14" },
    { rank: 4, prev: 6, team: "Loyola Academy", location: "Wilmette, IL", record: "20–1–2", points: 910, streak: "W7" },
    { rank: 5, prev: 4, team: "Strake Jesuit", location: "Houston, TX", record: "21–2–1", points: 884, streak: "W3" },
    { rank: 6, prev: 8, team: "McLean", location: "McLean, VA", record: "18–1–2", points: 860, streak: "W6" },
    { rank: 7, prev: 5, team: "Pittsford Sutherland", location: "Pittsford, NY", record: "19–0–2", points: 836, streak: "W8" },
    { rank: 8, prev: 10, team: "De La Salle", location: "Concord, CA", record: "20–2–1", points: 810, streak: "W4" },
    { rank: 9, prev: 7, team: "Marist", location: "Chicago, IL", record: "18–2–3", points: 786, streak: "W2" },
    { rank: 10, prev: 0, team: "Regis Jesuit", location: "Aurora, CO", record: "17–1–2", points: 760, streak: "W5" },
    { rank: 11, prev: 9, team: "Homestead", location: "Cupertino, CA", record: "18–1–3", points: 736, streak: "W1" },
    { rank: 12, prev: 13, team: "Bishop Kelley", location: "Tulsa, OK", record: "19–1–1", points: 712, streak: "W6" },
    { rank: 13, prev: 11, team: "Cathedral Catholic", location: "San Diego, CA", record: "18–2–2", points: 688, streak: "W3" },
    { rank: 14, prev: 0, team: "Broughton", location: "Raleigh, NC", record: "20–1–1", points: 664, streak: "W7" },
    { rank: 15, prev: 12, team: "St. Ignatius", location: "Cleveland, OH", record: "17–2–2", points: 640, streak: "W2" },
    { rank: 16, prev: 18, team: "Chaminade", location: "West Hills, CA", record: "18–2–1", points: 616, streak: "W4" },
    { rank: 17, prev: 14, team: "Brentwood", location: "Brentwood, TN", record: "19–1–2", points: 592, streak: "W5" },
    { rank: 18, prev: 15, team: "Grand Blanc", location: "Grand Blanc, MI", record: "20–1–1", points: 568, streak: "W1" },
    { rank: 19, prev: 21, team: "Berkeley Prep", location: "Tampa, FL", record: "18–2–2", points: 544, streak: "W6" },
    { rank: 20, prev: 16, team: "Xavier", location: "Phoenix, AZ", record: "17–3–1", points: 520, streak: "W2" },
    { rank: 21, prev: 0, team: "Wootton", location: "Rockville, MD", record: "18–1–2", points: 496, streak: "W8" },
    { rank: 22, prev: 19, team: "Lambert", location: "Suwanee, GA", record: "19–2–1", points: 472, streak: "W3" },
    { rank: 23, prev: 20, team: "Salpointe Catholic", location: "Tucson, AZ", record: "18–2–1", points: 448, streak: "W4" },
    { rank: 24, prev: 22, team: "Sunset", location: "Portland, OR", record: "17–2–2", points: 424, streak: "W2" },
    { rank: 25, prev: 23, team: "CBA", location: "Lincroft, NJ", record: "18–2–1", points: 400, streak: "W5" },
  ]),
  volleyball: build([
    { rank: 1, prev: 1, team: "Mater Dei", location: "Santa Ana, CA", record: "36–2", points: 1000, streak: "W22" },
    { rank: 2, prev: 2, team: "Marymount", location: "Los Angeles, CA", record: "34–3", points: 968, streak: "W11" },
    { rank: 3, prev: 5, team: "Cathedral Catholic", location: "San Diego, CA", record: "38–4", points: 940, streak: "W9" },
    { rank: 4, prev: 3, team: "Lovejoy", location: "Lucas, TX", record: "44–4", points: 914, streak: "W6" },
    { rank: 5, prev: 6, team: "Marist", location: "Atlanta, GA", record: "41–3", points: 888, streak: "W13" },
    { rank: 6, prev: 4, team: "Assumption", location: "Louisville, KY", record: "37–3", points: 862, streak: "W4" },
    { rank: 7, prev: 9, team: "Redondo Union", location: "Redondo Beach, CA", record: "33–5", points: 838, streak: "W7" },
    { rank: 8, prev: 7, team: "Bishop Chatard", location: "Indianapolis, IN", record: "35–3", points: 812, streak: "W3" },
    { rank: 9, prev: 11, team: "Skutt Catholic", location: "Omaha, NE", record: "36–2", points: 788, streak: "W15" },
    { rank: 10, prev: 0, team: "Sacred Heart", location: "Louisville, KY", record: "34–4", points: 762, streak: "W5" },
    { rank: 11, prev: 8, team: "Papillion-La Vista South", location: "Papillion, NE", record: "33–4", points: 738, streak: "W2" },
    { rank: 12, prev: 13, team: "Prosper", location: "Prosper, TX", record: "42–5", points: 714, streak: "W6" },
    { rank: 13, prev: 10, team: "Notre Dame", location: "Sherman Oaks, CA", record: "31–6", points: 690, streak: "W1" },
    { rank: 14, prev: 0, team: "Providence", location: "San Antonio, TX", record: "38–3", points: 666, streak: "W8" },
    { rank: 15, prev: 12, team: "McDonogh", location: "Owings Mills, MD", record: "30–4", points: 642, streak: "W3" },
    { rank: 16, prev: 18, team: "Hamilton", location: "Chandler, AZ", record: "34–4", points: 618, streak: "W5" },
    { rank: 17, prev: 14, team: "St. James", location: "Montgomery, AL", record: "48–7", points: 594, streak: "W4" },
    { rank: 18, prev: 15, team: "Benet Academy", location: "Lisle, IL", record: "36–3", points: 570, streak: "W2" },
    { rank: 19, prev: 21, team: "Torrey Pines", location: "San Diego, CA", record: "32–5", points: 546, streak: "W6" },
    { rank: 20, prev: 16, team: "Mother McAuley", location: "Chicago, IL", record: "33–5", points: 522, streak: "W1" },
    { rank: 21, prev: 0, team: "Bishop Moore", location: "Orlando, FL", record: "29–3", points: 498, streak: "W7" },
    { rank: 22, prev: 19, team: "Mira Costa", location: "Manhattan Beach, CA", record: "30–6", points: 474, streak: "W2" },
    { rank: 23, prev: 20, team: "Volcano Vista", location: "Albuquerque, NM", record: "22–2", points: 450, streak: "W9" },
    { rank: 24, prev: 22, team: "Penn", location: "Mishawaka, IN", record: "35–3", points: 426, streak: "W3" },
    { rank: 25, prev: 23, team: "Coppell", location: "Coppell, TX", record: "40–6", points: 402, streak: "W4" },
  ]),
};

export const NAV_LINKS = [
  { label: "Rankings", href: "#rankings" },
  { label: "Sports", href: "#sports" },
  { label: "News", href: "#news" },
  { label: "The Model", href: "#model" },
  { label: "About", href: "#about" },
];

export const SPOTLIGHTS = [
  {
    tag: "Team of the Week",
    title: "Mater Dei stays untouchable",
    excerpt:
      "A 42–10 statement over St. John Bosco keeps the Monarchs at No. 1 for a seventh straight week.",
    image: "https://images.unsplash.com/photo-1663565197860-eee65f0b3f3c",
    sport: "Football",
  },
  {
    tag: "Biggest Riser",
    title: "Buford climbs into the top six",
    excerpt:
      "An unbeaten 14–0 run and a dominant title-game showing pushed the Wolves up two spots.",
    image: "https://images.unsplash.com/photo-1748111405983-d1b10316eb83",
    sport: "Soccer",
  },
  {
    tag: "Watch List",
    title: "Columbus surges nationally",
    excerpt:
      "A 12-game win streak has the Explorers knocking on the door of the No. 1 spot.",
    image: "https://images.unsplash.com/photo-1543633550-f431af584afd",
    sport: "Basketball",
  },
];

export const STATS = [
  { value: "12,400+", label: "Programs tracked" },
  { value: "48", label: "States covered" },
  { value: "6", label: "Sports ranked" },
  { value: "Weekly", label: "Model refresh" },
];

export const MODEL_STEPS = [
  {
    step: "01",
    title: "Every result, every week",
    body: "We ingest scores from thousands of programs, then weight each game by opponent quality and margin.",
  },
  {
    step: "02",
    title: "Strength of schedule",
    body: "A win over a top-10 team moves the needle far more than a blowout of an unranked opponent.",
  },
  {
    step: "03",
    title: "Human review",
    body: "Our editorial board reviews the model output each Sunday and publishes the final Top 25.",
  },
];
